module.exports = __webpack_public_path__ + "static/media/ayuda.6b9332e5.svg";